/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type HeartWrapper_viewer$ref = any;
export type Recommendations_trending$ref = any;
export type Recommendations_trending = {
    readonly trendingCategories: ReadonlyArray<{
        readonly displayName: string | null;
        readonly url: string | null;
    } | null> | null;
    readonly trendingAttributes: ReadonlyArray<{
        readonly displayName: string | null;
        readonly url: string | null;
    } | null> | null;
    readonly " $fragmentRefs": HeartWrapper_viewer$ref;
    readonly " $refType": Recommendations_trending$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Literal",
        "name": "numItems",
        "value": 2
    } as any), v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "displayName",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "url",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "Recommendations_trending",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "loadPortfolioData",
                "type": null
            },
            {
                "kind": "RootArgument",
                "name": "selectedItemIds",
                "type": null
            },
            {
                "kind": "RootArgument",
                "name": "userIds",
                "type": null
            }
        ],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "trendingCategories",
                "name": "trending",
                "storageKey": "trending(categoryLevels:3,numItems:2,trendType:\"CATEGORY\")",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "categoryLevels",
                        "value": 3
                    },
                    (v0 /*: any*/),
                    {
                        "kind": "Literal",
                        "name": "trendType",
                        "value": "CATEGORY"
                    }
                ],
                "concreteType": "TrendingModules",
                "plural": true,
                "selections": (v1 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": "trendingAttributes",
                "name": "trending",
                "storageKey": "trending(numItems:2,trendType:\"ATTRIBUTE\")",
                "args": [
                    (v0 /*: any*/),
                    {
                        "kind": "Literal",
                        "name": "trendType",
                        "value": "ATTRIBUTE"
                    }
                ],
                "concreteType": "TrendingModules",
                "plural": true,
                "selections": (v1 /*: any*/)
            },
            {
                "kind": "FragmentSpread",
                "name": "HeartWrapper_viewer",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "loadPortfolioData",
                        "variableName": "loadPortfolioData"
                    },
                    {
                        "kind": "Variable",
                        "name": "selectedItemIds",
                        "variableName": "selectedItemIds"
                    },
                    {
                        "kind": "Variable",
                        "name": "userIds",
                        "variableName": "userIds"
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '018c30ccf42cc2d9ae997b002dc2a2af';
export default node;
